import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { propChildren, propStr } from '../../../helpers/custom-prop-types';
/**
 * @deprecated TS化済: src/components/functional/portal/Portal/Portal.tsx
 */
const ModalPortal = (props) => {
    const { children, selector } = props;
    const [el, changeEl] = useState();
    useEffect(() => {
        changeEl(document.querySelector(selector));
    }, [changeEl, selector]);
    return el ? createPortal(children, el) : null;
};
ModalPortal.propTypes = {
    children: propChildren().isRequired,
    selector: propStr(),
};
ModalPortal.defaultProps = {
    selector: '.l-main',
};
export default ModalPortal;
